import React, { useEffect, useMemo, useRef, useState } from 'react';
import './VoucherDetailTable.scss'
import { DeleteOutlined, DownloadOutlined, SearchOutlined, SettingOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Checkbox, ConfigProvider, DatePicker, Form, FormInstance, Input, Modal, Pagination, PaginationProps, Select, SelectProps, Switch, Tabs, TabsProps, Tooltip, notification } from 'antd';
import viVN from 'antd/locale/vi_VN';
import { AllCommunityModule, ColDef, ModuleRegistry } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import useToast from '../../../hook/useToast';
import useDebounce from '../../../hook/useDebounce';
import * as voucherApi from '../../../api/voucher/voucherApi';
import { createGroupedSelectOptionsV2, dataPagination, fommatSelectOptionUnitByUser, fommatSelectOptionV2, formatPrice, getTitleSelectOption, getWidthFromHeaderV2 } from '../../../until';
import useThrottle from '../../../hook/useThrottle';
import * as XLSX from 'xlsx';
import { LIMIT_EXPORT_EXCEL, NO_DATA } from '../../../env';
import { formatNumber } from '../../../services/mixin';
import { NodataTable } from '../../../components/NoDataTable';
import useLoading from '../../../hook/useLoading';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../../store/slices/infoUserSlice';
import { selectorUnitByUserPermission } from '../../../store/slices/UnitByUserPermission';
import { useWatch } from 'antd/es/form/Form';
import customParseFormat from "dayjs/plugin/customParseFormat";
import { FIELDTYPE, VoucherDetailStatusEnum, VoucherTypeTable } from '../../../services/data';
import { IVoucherData } from '../../../hook/useVoucherDetail';
import { getSlContractsAndInvoices, ISLContractsAndInvoices } from '../../../api/selectOptions/selectOptionsApi';
import { Link } from 'react-router-dom';
import { getListFieldsByCustomer, IField, ListField } from '../../../api/Customer_V2/customerApi_V2';
import CustomerFeilds from '../../CustomersV2/Drawer/CustomerFeilds';
import { FlattenedField } from '../../CustomersV2/indexV2';
import CustomerVoucherFeilds from './CustomerVoucherFeilds';
dayjs.extend(customParseFormat);

ModuleRegistry.registerModules([AllCommunityModule]);

const { Search } = Input;

type FieldType = {
  customerName?: string;
  unitId?: string;
  date?: string;
}

type Props = {
  id: number
  activeKey: string
  dataFilter: string
  infoVoucher?: voucherApi.IVoucherEdit
  voucherTableDetailData?: IVoucherData

  setActiveKey: (e: string) => void
  setDataFilter: React.Dispatch<React.SetStateAction<string>>
  setVoucherTableDetailData?: React.Dispatch<React.SetStateAction<IVoucherData>>
  gInfoVoucher?: () => Promise<void>
  reloadVoucherList?: (...args: any) => void
};

const VoucherDetailTable: React.FC<Props> = ({
  id, activeKey, dataFilter,
  infoVoucher, voucherTableDetailData,
  setActiveKey, setDataFilter,
  setVoucherTableDetailData,
  gInfoVoucher, reloadVoucherList

}) => {


  const unitByUserPermissionSlice = useSelector(selectorUnitByUserPermission)

  const { unitTemp, } = useSelector(selectorInfoUser) // đợn vị dc chọn



  const pushLoading = useLoading()
  const pushToast = useToast();
  const [form] = Form.useForm();

  const customersWatch = useWatch('customers', form);

  const start = dayjs(
    `${infoVoucher?.actualStartTime} ${infoVoucher?.timeStart}`,
    "DD/MM/YYYY HH:mm"
  );

  const end = dayjs(
    `${infoVoucher?.dateEnd} ${infoVoucher?.timeEnd}`,
    "DD/MM/YYYY HH:mm"
  );

  const [isModalShow, setModalShow] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [isSettingShow, setSettingShow] = useState(false)
  const [activeFields, setActiveFields] = useState<FlattenedField[]>([])
  const [inactiveFields, setInactiveFields] = useState<ListField[]>([])

  const gListFieldsActive = async () => {
    const result = await getListFieldsByCustomer(FIELDTYPE.VoucherCodeDetail, 1)
    if (result?.status) {
      const flattenedFields: FlattenedField[] = result.data.flatMap(choice =>
        choice.fields.map(field => ({
          ...field,
          parentId: choice.id,
        }))
      );
      setActiveFields(flattenedFields)
      gListFieldsNotActive()
    }
  }

  const gListFieldsNotActive = async () => {
    const result = await getListFieldsByCustomer(FIELDTYPE.VoucherCodeDetail, 0)
    if (result?.status) {
      setInactiveFields(result.data)
    }
  }

  const onSaveDataFields = (iSsuccess?: boolean, message?: string, updatedActive?: FlattenedField[], updatedInactive?: ListField[]) => {
    if (iSsuccess) {
      setSettingShow(false)
      pushToast(message, "success")
      setActiveFields(updatedActive ?? [])
      setInactiveFields(updatedInactive ?? [])
    } else {
      pushToast(message, "warning")
    }
  }

  const tabItems: TabsProps['items'] = [
    { label: `Tất cả`, key: "2" },
    { label: `Chưa đổi${voucherTableDetailData?.unused.pagination.total ? ` (${formatPrice(voucherTableDetailData?.unused.pagination.total)})` : ''}`, key: "0" },
    { label: `Đã đổi${infoVoucher?.redeemedVoucherQuantity ? ` (${formatPrice(infoVoucher.redeemedVoucherQuantity)})` : ''}`, key: "1" },
  ];

  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  const [invoicesByCustomer, setInvoicesByCustomer] = useState<Record<number, SelectProps["options"]>>({});


  const currentList = {
    [VoucherTypeTable.ALL.toString()]: voucherTableDetailData?.all.list,
    [VoucherTypeTable.UN_USE.toString()]: voucherTableDetailData?.unused.list,
    [VoucherTypeTable.USED.toString()]: voucherTableDetailData?.used.list,
  }[activeKey]

  const currentPagination = {
    [VoucherTypeTable.ALL.toString()]: voucherTableDetailData?.all.pagination,
    [VoucherTypeTable.UN_USE.toString()]: voucherTableDetailData?.unused.pagination,
    [VoucherTypeTable.USED.toString()]: voucherTableDetailData?.used.pagination,
  }[activeKey]


  const columnDefs = useMemo<ColDef<voucherApi.IVoucherCode>[]>(() => {
    const fixedColumns: ColDef<voucherApi.IVoucherCode>[] = [
      {
        headerName: '',
        width: 50,
        field: 'isUsedUp',
        cellRenderer: (params: any) => (
          <div className="d-flex align-center h-full">
            <Checkbox
              className="rs-switch rs-switch--sm"
              disabled={params.data.isUsedUp || !params.data.isActive}
              checked={selectedIds.has(params.data.id.toString())}
              onChange={(e) => {
                const checked = e.target.checked;
                setSelectedIds(prev => {
                  const newSet = new Set(prev);
                  if (checked) {
                    newSet.add(params.data.id.toString());
                  } else {
                    newSet.delete(params.data.id.toString());
                  }
                  return newSet;
                });
              }}
            />
          </div>
        ),
        lockPosition: 'left',
        resizable: false,
      },
      {
        headerName: 'Hành động',
        field: 'id',
        width: 100,
        sortable: false,
        cellRenderer: (params: any) => (
          <div className="d-flex align-center h-full">
            <Switch
              disabled={infoVoucher?.status !== VoucherDetailStatusEnum.ACTIVE}
              value={params.data.isActive}
              className="rs-switch rs-switch--sm"
              onChange={() => onChangeActiveCode(params.data.isActive, params.data.id)}
            />
          </div>
        ),
        resizable: false,
        suppressMovable: true,
        lockPosition: 'left',
      },
    ];

    const dynamicColumns: ColDef[] = activeFields.map(field => {
      const col: ColDef = {
        headerName: field.fieldLabel,
        field: field.fieldCode,
        minWidth: getWidthFromHeaderV2(field.fieldLabel),
      };

      if (field.fieldCode === 'customerName' || field.fieldCode === 'cus_name') {
        col.cellRenderer = (params: any) => {
          const customerId = params?.data?.customerId;
          const displayName = params.value;
          return (
            <Tooltip
              placement="right"
              color="white"
              title={
                <span className="custom-page-css" style={{ color: "#000", textTransform: 'capitalize' }}>
                  {displayName}
                </span>
              }
            >
              <Link
                style={{ color: "#1890ff", textTransform: 'capitalize' }}
                to={`/customer/list/edit`}
                state={{
                  firstPage: '/marketing/vouchers-management/access',
                  idFirstPage: infoVoucher?.id,
                  id: customerId,
                }}
              >
                {displayName}
              </Link>
            </Tooltip>
          );
        };
      }

      return col;
    });

    return [...fixedColumns, ...dynamicColumns];
  }, [currentPagination?.current, currentPagination?.pageSize, infoVoucher, voucherTableDetailData, selectedIds, activeFields])

  const gListVoucherCodeByExcel = useThrottle(async () => {
    const result = await voucherApi.getListVoucherCode(id, LIMIT_EXPORT_EXCEL, 1, Number(activeKey), dataFilter)
    if (result?.status) {
      formattedDataExcel(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }, 2000)

  // số hóa đơn - Gọi trực tiếp không debounce
  const fetchSlContractsAndInvoices = async (idCustomer: number, search?: string, fieldIndex?: number) => {
    if (!idCustomer) return;
    pushLoading(true);
    try {
      const result = await getSlContractsAndInvoices(idCustomer, search);
      if (result?.status) {
        const options = createGroupedSelectOptionsV2(result.data);
        setInvoicesByCustomer(prev => ({
          ...prev,
          [idCustomer]: options
        }));

        // const allChildren = result?.data?.flatMap((g: ISLContractsAndInvoices) => g.children || []) || [];
        // if (allChildren.length === 1 && fieldIndex !== undefined) {
        //   form.setFieldValue(["customers", fieldIndex, "invoiceNumber"], allChildren[0].id);
        // }
      }
    } catch (e) {
      console.error(e);
    } finally {
      pushLoading(false);
    }
  };

  // số hóa đơn - Phiên bản debounce khi người dùng gõ tìm kiếm (onSearch)
  const searchSlContractsAndInvoicesDebounced = useDebounce(async (idCustomer: number, search?: string, fieldIndex?: number) => {
    await fetchSlContractsAndInvoices(idCustomer, search, fieldIndex);
  }, 1000);


  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    reloadVoucherList?.(pageNumber, pageSize)
  }

  const onChangeActiveCode = useThrottle(async (value: boolean, codeId: number) => {
    pushLoading(true)
    const result = await voucherApi.activeVoucherCode(codeId)
    if (result?.status) {
      reloadVoucherList?.()
      pushToast(result?.message, "success")
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)

  }, 1000)

  const formattedDataExcel = (data: voucherApi.IVoucherCode[]) => {
    const formattedData = data.map((item) => ({
      "Trạng thái": item.usageText,
      "Mã Voucher": item.code,
      "Khách hàng": item.customerName,
      "Số điện thoại": item.phone,
      "Ngày quy đổi": item.conversionDate,
      "Cửa hàng/ đại lý": item.agentName
    }));
    exportExcel(formattedData)
  }

  const exportExcel = (convertData: any): boolean => {
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Danh sách');
      const excelBuffer: ArrayBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
      const data: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
      const link: HTMLAnchorElement = document.createElement('a');
      link.href = window.URL.createObjectURL(data);
      link.download = 'Danh sách voucher.xlsx';
      link.click();
      return true;
    } catch (error) {
      console.error('Error exporting Excel:', error);
      return false;
    }
  }



  const handleOk = async (values: any) => {
    // setConfirmLoading(true);
    const convertedData = values?.customers.map((item: any) => {
      const [invoiceCode, type] = item.invoiceNumber.split("-%-");

      return {
        voucherCodeId: item.id,
        customerId: item.customerId,
        invoiceCode: invoiceCode,
        type: Number(type),
      };
    });
    try {
      const customers = values.customers || [];
      const ids = customers.map((c: any) => c.id);

      if (ids.length === 0) {
        pushToast("Vui lòng chọn ít nhất một khách hàng để quy đổi", "warning");
        setConfirmLoading(false);
        return;
      }

      if (!values.date) {
        pushToast("Vui lòng chọn ngày quy đổi", "warning");
        setConfirmLoading(false);
        return;
      }

      const dateTmp = values.date.format("YYYY/MM/DD");
      const result = await voucherApi.conversionVoucher(convertedData, unitTemp, dateTmp);
      if (result?.status) {
        gInfoVoucher?.();
        reloadVoucherList?.();
        pushToast(result?.message, "success");
        setModalShow(false);
        setSelectedIds(new Set())

      } else {
        pushToast(result?.message, "warning");
      }
    } catch (error) {
      console.error(error);
      pushToast("Có lỗi xảy ra khi quy đổi", "warning");
    } finally {
      setConfirmLoading(false);
    }
  };

  const formRef = useRef<FormInstance<FieldType>>(null);
  const onSubmitForm = () => { formRef.current?.submit() }

  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    gListFieldsActive()
  }, [])

  useEffect(() => {
    reloadVoucherList?.()
  }, [dataFilter, activeKey])

  useEffect(() => {
    if (isModalShow) {
      // Chỉ khởi tạo khi form chưa có dữ liệu danh sách khách hàng để tránh việc reset dữ liệu khi xóa dòng
      const currentCustomers = form.getFieldValue('customers');
      if (currentCustomers && currentCustomers.length > 0) {
        return;
      }

      const list = currentList?.filter((item: any) => selectedIds.has(item.id.toString())) || [];
      const customersData = list.map((item: any) => ({
        id: item.id,
        customerId: item.customerId,
        name: item.customerName || NO_DATA,
        invoiceNumber: undefined,
      }));
      form.setFieldsValue({
        unitId: getTitleSelectOption(fommatSelectOptionUnitByUser(unitByUserPermissionSlice), unitTemp),
        date: undefined,
        customers: customersData,
      });

      // Tải trước danh sách hóa đơn cho từng khách hàng (gọi song song trực tiếp)
      customersData.forEach((cust: any, index: number) => {
        if (cust.customerId) {
          fetchSlContractsAndInvoices(cust.customerId, "", index);
        }
      });
    } else {

      form.resetFields();
      setInvoicesByCustomer({});
    }
  }, [isModalShow, currentList, selectedIds]);

  return (
    <>
      {contextHolder}

      <CustomerVoucherFeilds
        isSettingShow={isSettingShow}
        recordId={FIELDTYPE.VoucherCodeDetail}
        dataFilterActive={activeFields}
        dataFilterNoActive={inactiveFields}
        onSaveDataFields={onSaveDataFields}
        onClose={() => setSettingShow(false)}
      />

      <div className="voucher-detail-table">
        <div className="top">
          <span className="title">Danh sách voucher</span>

          <div className="custom-page-css flex items-center justify-end gap-2">
            <div className='custom-page-css h-full flex flex-2'>
              <div className="custom-page-css w-full h-full flex items-center justify-between flex-2 border bg-FCFCFD rounded  ">
                <Input
                  placeholder="Tìm chương trình Voucher"
                  className=' custom-input-css custom-page-css outline-none border-none'
                  value={dataFilter}
                  onChange={(e) => setDataFilter(e.target.value)}
                />
                <div className="border-l-F2F4F7 h-full d-flex align-center">
                  <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                </div>
              </div>
            </div>
            <Button className="">
              <UploadOutlined />
              <span>Nhập DS</span>
            </Button>

            <Button className="" onClick={gListVoucherCodeByExcel}>
              <DownloadOutlined />
              <span>Xuất DS</span>
            </Button>

            <Button className="" icon={<SettingOutlined />} onClick={() => setSettingShow(true)} />
          </div>
        </div>
        <div className="custom-page-css w-full flex justify-between items-center gap-3">
          <Tabs
            activeKey={activeKey}
            items={tabItems}
            className='rs-tabs'
            onChange={(e: any) => setActiveKey(e)}
          />
          <Button
            // className='custom-page-css h-full flex items-center gap-2 px-2 py-6px rounded border bg-096DD9 text-white cursor-pointer'
            type='primary'

            style={{ padding: '0 12px' }}
            onClick={() => setModalShow(true)}
            disabled={!selectedIds.size}
          >
            Quy đổi
          </Button>
        </div>
        <div className="ag-theme-alpine empty-test-td custom-table-ag-v2" style={{ width: '100%' }}>
          <AgGridReact
            domLayout="autoHeight"
            rowData={currentList}
            columnDefs={columnDefs}
            defaultColDef={{ resizable: true }}
            rowHeight={55}
            suppressDragLeaveHidesColumns={true}
            overlayNoRowsTemplate={NodataTable}
            getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 === 0 ? '#ffffff' : '#f7f9fc',
            })}
          />
        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination
              showSizeChanger
              current={currentPagination?.current}
              pageSize={currentPagination?.pageSize}
              total={currentPagination?.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(currentPagination?.total || 0, currentPagination?.pageSize || 0, currentPagination?.current || 0).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}
            />
          </div>
        </ConfigProvider>
      </div>

      <Modal
        title="Quy đổi voucher"
        open={isModalShow}
        centered
        confirmLoading={confirmLoading}
        footer={[
          <Button key="submit" type="primary" loading={confirmLoading} onClick={onSubmitForm} className="rs-button">
            Quy đổi
          </Button>,
        ]}
        className="rs-modal w-600"
        width={600}
        onCancel={() => setModalShow(false)}
        destroyOnClose
      >
        <Form
          form={form}
          ref={formRef}
          name="basic"
          autoComplete="off"
          className="rs-form voucher-update-form"
          onFinish={handleOk}
          initialValues={{
            unitId: getTitleSelectOption(fommatSelectOptionUnitByUser(unitByUserPermissionSlice), unitTemp)
          }}
        >
          <span className='custom-page-css text-sm text-344054 ' style={{ display: 'block', marginBottom: '12px', fontWeight: 500 }}>
            Xác nhận quy đổi {customersWatch?.length || 0} khách hàng
          </span>
          {/* <Form.Item<FieldType> name="unitId" rules={[{ required: true, message: 'Vui lòng nhập đơn vị quy đổi!' }]}>
            <Input disabled placeholder="Đơn vị quy đổi" className="custom-input-css custom-page-css border " />
          </Form.Item> */}

          <Form.Item name="unitId" rules={[{ required: true, message: 'Vui lòng nhập đơn vị quy đổi!' }]}>
            {/* <Input disabled placeholder="Đơn vị quy đổi" className="custom-input-css custom-page-css border " /> */}
            <Select
              className="custom-page-css border rounded w-full"
              placeholder="Đơn vị quy đổi"
              showSearch
              allowClear
              filterOption={false}

              options={fommatSelectOptionV2(infoVoucher?.appliedUnitsList ?? [])}
            />
          </Form.Item>
          <Form.Item
            name="date"
            initialValue={dayjs()}
            rules={[{ required: true, message: 'Vui chọn ngày quy đổi!' }]}
          >
            <DatePicker
              format="DD/MM/YYYY"
              placeholder="Ngày quy đổi"
              className="custom-input-date custom-page-css w-full"
              popupClassName="rs-date-picker-dropdown"
              disabledDate={(current) => {
                if (!current) return false;

                return (
                  current.isBefore(start, "day") ||
                  current.isAfter(end, "day")
                );
              }}
            />
          </Form.Item>

          <div className="conversion-customer-list-container">
            <div className="conversion-customer-header">
              <div className="col-action">Thao tác</div>
              <div className="col-name">Khách hàng</div>
              <div className="col-invoice">Số hóa đơn</div>
            </div>
            <div className="conversion-customer-body">
              <Form.List name="customers">
                {(fields, { remove }) => (
                  <>
                    {fields.map((field) => {
                      const currentCustomer = form.getFieldValue(['customers', field.name]);
                      const customersValue = form.getFieldValue('customers')
                      return (
                        <div key={field.key} className="conversion-customer-row">
                          <div className="col-action">
                            <div
                              className="delete-btn"
                              onClick={() => {
                                const customersValue = form.getFieldValue('customers');
                                const deletedCustomerId = customersValue[field.name]?.id;
                                if (deletedCustomerId) {
                                  setSelectedIds((prev) => {
                                    const newSet = new Set(prev);
                                    newSet.delete(deletedCustomerId.toString());
                                    return newSet;
                                  });
                                }
                                remove(field.name);
                              }}
                            >
                              <DeleteOutlined />
                            </div>
                          </div>
                          <div className="col-name">
                            {currentCustomer?.name}
                          </div>
                          <div className="col-invoice">
                            <Form.Item
                              {...field}
                              name={[field.name, 'invoiceNumber']}
                              noStyle
                              rules={[{ required: true, message: 'Chọn hóa đơn!' }]}
                            >
                              <Select
                                className="custom-page-css border rounded"
                                placeholder="Số hóa đơn"
                                showSearch
                                allowClear
                                filterOption={false}
                                onSearch={(value) => {
                                  if (currentCustomer?.customerId) {
                                    searchSlContractsAndInvoicesDebounced(currentCustomer.customerId, value, field.name);
                                  }
                                }}
                                options={invoicesByCustomer[currentCustomer?.customerId] || []}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}
              </Form.List>
            </div>
          </div>

          <div className="warning-block">
            <p className="warning-text">
              Vui lòng kiểm tra và xác nhận thông tin trước khi quy đổi, thao tác này không thể hoàn tác.
            </p>
          </div>
        </Form>
      </Modal>
    </>
  );
}

export default VoucherDetailTable;
